
import React, { PureComponent } from 'react';
import resl from 'resl';
// import app_cs from './App.module.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import './slick-theme.css';
import 'whatwg-fetch';
import keyBy from 'lodash.keyby';
import _ from 'lodash';
import $ from 'jquery';
import Cylinder from'./components/mCylinder';
import Disable from'./components/Disable/index.js';

// home_bg.png
import home_title from '../../assets/images/m/home_title.png'
import cgtn from '../../assets/images/m/cgtn.png';
import home_1 from '../../assets/images/m/home_1.png';
import home_1_1 from '../../assets/images/m/home_1_1.png';
import m_1991_1 from '../../assets/images/m/m_1991_1.png';
import m_1991_2 from '../../assets/images/m/m_1991_2.png';
import m_1991_3 from '../../assets/images/m/m_1991_3.png';
import m_1991_4 from '../../assets/images/m/m_1991_4.png';
import m_1994 from '../../assets/images/m/m_1994.png';
import m_1999_1 from '../../assets/images/m/m_1999_1.png';
import m_1999_2 from '../../assets/images/m/m_1999_2.png';
import m_1999_i from '../../assets/images/m/m_1999_i.jpeg';
import m_2004 from '../../assets/images/m/m_2004.png';
import m_2008 from '../../assets/images/m/m_2008.png';
import m_2008_i from '../../assets/images/m/m_2008_i.jpeg';
import m_2009 from '../../assets/images/m/m_2009.png';
// import m_2009_1 from '../../assets/images/m/m_2009_1.png';
import m_2013 from '../../assets/images/m/m_2013.png';
import m_2014 from '../../assets/images/m/m_2014.png';
import m_2019 from '../../assets/images/m/m_2019.png';
import m_2022 from '../../assets/images/m/m_2022.png';


import icon_pop from '../../assets/images/m/icon_pop.png';
import icon_gas from '../../assets/images/m/icon_gas.png';
import img_nuclear from '../../assets/images/m/img_nuclear.png';
import icon_nuclear from '../../assets/images/m/icon_nuclear.png';
import img_money from '../../assets/images/m/img_money.png';
import icon_money from '../../assets/images/m/icon_money.png';
// img_money


import img_agriculture from '../../assets/images/m/img_agriculture.png';
import img_arrow_1 from '../../assets/images/m/img_arrow_1.png';
import img_arrow_2 from '../../assets/images/m/img_arrow_2.png';
import img_arrow_3 from '../../assets/images/m/img_arrow_3.png';
import img_arrow_4 from '../../assets/images/m/img_arrow_4.png';
import img_arrow_5 from '../../assets/images/m/img_arrow_5.png';
import img_gas from '../../assets/images/m/img_gas.png';
import img_gas_arrow_1 from '../../assets/images/m/img_gas_arrow_1.png';
import img_gas_arrow_2 from '../../assets/images/m/img_gas_arrow_2.png';

import m_cgtn from '../../assets/images/m/m_cgtn.png';


import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

import './m_app.css'
gsap.registerPlugin(ScrollTrigger);

//  m_1999_1,
const images = [home_1_1, home_1_1,home_1_1,home_1_1,home_1_1, m_1991_1,m_1994, m_1999_1,m_2004,m_2008,m_2009,m_2013,m_2014,m_2019,m_2022];
// const data_map2 = keyBy(map2_json.content, obj=>obj.name)
// console.log('data_map2', data_map2)
const images_1991 = [m_1991_1,m_1991_2,m_1991_3,m_1991_4];

window.jwplayer.key = "44Q5I+IeRJNSOKmj+UHDkKYQrWx3R2iz4Og48gAQJUKRwMOK"

class M extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            onOff : true
        }
        this.currentIndex = 0;
        this.flag = {}; // 1991
        this.flag2009 = {}
        this.flag2014 = {}
        this.flag1999 = {};
    }
    componentDidMount() {
       let _this = this;
        
        $(window).resize(() => {
            _this.resize()
        }).trigger('resize')
        // 顶部滚动条 
        const scrollHeight = Math.max(
            document.body.scrollHeight, document.documentElement.scrollHeight,
            document.body.offsetHeight, document.documentElement.offsetHeight,
            document.body.clientHeight, document.documentElement.clientHeight
        );
        let content_bg = document.querySelector('.content-bg');
        // window.addEventListener('scroll',
        //  (e) => {
        //     document.querySelector('progress').value = window.pageYOffset / (scrollHeight - window.innerHeight) * 100;
        // })
        let tl2 = gsap.timeline();
        tl2.to('.m-home2',{
            duration:.8,
            // ease:'none',
            scrollTrigger:{
                trigger:'.m-home2',
                start:'top bottom-=2%',
                end:'top bottom-=3%',
                // markers:true,
                onEnter:()=>{
                    $('.m-home1').animate({opacity:0},500)
                },
                onEnterBack:()=>{
                    $('.m-home1').animate({opacity:1},500)
                }
            }
        })
          
        gsap.utils.toArray('.content-section').map((section,i)=>{
            let _leng = $(".content-section").length
            section.content = section.querySelector(".content");
            section.bg = section.querySelector(".bg");
            section.content_time = section.querySelector(".content-time");
            section.content = section.querySelector('.content');
            section.content_time_placeholder = section.querySelector('.content-time-placeholder');
            section.title_end = section.querySelector('.title-end');
            var tl = gsap.timeline();
            let data_num = $(section).attr('data-num');
            section.bg.style.backgroundImage = `url(${images[i]})`;
            if(data_num ==1991 || data_num ==1999 || data_num == 2009 || data_num == 2014 ){
                var tl2 = gsap.timeline();
                section.bg.style.opacity = 0;
                section.bg.style.backgroundImage = ''
            }
            let _height = 5.35*this.rule_num;
            tl.to(section, {
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    // pin:section.bg,
                    // pin:section.content_time,
                    start:"top bottom",
                    // start:()=>{
                    //     if(data_num ==1991){
                    //         return "top bottom-=30%";
                    //     }else{
                    //         return "top bottom";
                    //     }
                    // },
                    end: "bottom top+=10%",
                    fastScrollEnd:true,
                    preventOverlaps:true,
                    // scrub:true,
                    onUpdate:({progress})=>{
                        // console.log(this.rule_num,'this.rule_num');
                        let title_client = section.querySelector('.content').getClientRects();
                        
                        // console.log(title_client);
                        // console.log(title_client[0].y);
                        // if(!$(section.content_time).hasClass('content-time-fixed')){
                        //     console.log('1111');
                        //     if(title_client[0].y <= 0){
                        //     console.log('1111');

                        //         _.throttle(()=>{
                        //             $(section.content_time).addClass('content-time-fixed');
                        //             $(section.content_time_placeholder).css({"position":'unset'});
                        //         },200,{leading:true})
                                
                        //     }
                        // }
                        let _title_end = section.querySelector('.title-end');
                        if(_title_end && data_num != 1991){
                            let title_end = section.querySelector('.title-end').getClientRects();
                            _.throttle(()=>{
                                if(title_client[0].y <= 20){
                                    // console.log('1111');
                                    $(section.content_time).addClass('content-time-fixed');
                                    $(section.content_time_placeholder).css({"position":'unset'});
                                }
                            },300,{leading:true})();
                            _.throttle(()=>{
                                if(title_client[0].y > 4 || title_end[0].y < _height){
                                    $(section.content_time).removeClass('content-time-fixed');
                                    $(section.content_time_placeholder).css({"position":'fixed'});
                                }
                            },300,{leading:true})();
                        }
                        
                       
                        if(data_num == 1991){
                            // console.log('data_num==>', progress);
                            section.bg_1991_2 = section.querySelector('.bg-1991-2');
                            section.bg_1991_1 = section.querySelector('.bg-1991-1');
                            section.bg_1991_3 = section.querySelector('.bg-1991-3');
                            section.bg_1991_4 = section.querySelector('.bg-1991-4');
                            if(0<= progress && progress<=0.25 && !_this.flag.image1){
                                // console.log('0000');
                                tl2.to(section.bg_1991_2,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_3,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_4,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_1,{
                                    opacity:1,
                                    duration:.6,
                                },'-=0.9');
                                _this.flag= {
                                    image1:true
                                };
                            }
                            if(0.25<progress && progress<=0.5 && !_this.flag.image2){
                                // console.log('111');
                                tl2.to(section.bg_1991_1,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_3,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_4,{
                                    opacity:0,
                                    duration:.3,
                                }).to(section.bg_1991_2,{
                                    opacity:1,
                                    duration:1.2,
                                },'-=1');
                                _this.flag= {
                                    image2:true
                                };
                            }
                            if(0.5<progress && progress<=0.7 &&  !_this.flag.image3){
                                // console.log('222');
                                tl2.to(section.bg_1991_1,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_2,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_4,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_3,{
                                    opacity:1,
                                    duration:.8,
                                },'-=0.6');
                                // _this.flag.image3 = true;
                                _this.flag= {
                                    image3:true
                                };
                            }
                            if(0.7<progress && progress<=1 &&  !_this.flag.image4){
                                // console.log('3333');
                                tl2.to(section.bg_1991_1,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_2,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_3,{
                                    opacity:0,
                                    duration:.2,
                                }).to(section.bg_1991_4,{
                                    opacity:1,
                                    duration:.8,
                                },'-=0.7');
                                _this.flag= {
                                    image4:true
                                };
                            }
                        }
                        if(data_num == 1999){
                            if(0<= progress && progress<=0.25 && !_this.flag1999.image1){
                                section.bg_zoomOut  =  section.querySelector('.bg-zoomOut');
                                section.bg_1999  =  section.querySelector('.bg-1999');
                                section.m_1999_font  =  section.querySelector('.m_1999_font');
                                tl.to(section.bg_1999,{
                                    delay:1,
                                    opacity:0,
                                    scale:1.55,
                                    // translate(-2.6rem,-0.5rem)
                                    x:'-4rem',
                                    y:'-0.9rem',
                                    duration:2
                                }).to(section.m_1999_font,{
                                    opacity:0,
                                    duration:.3,
                                },'<').to(section.bg_zoomOut,{
                                    // delay:0.4,
                                    opacity:1,
                                    scale:1.55,
                                    x:'-4rem',
                                    y:'-0.9rem',
                                    duration:2,
                                },'-=2').to('.m_1999_2_2_front',{
                                    opacity:1,
                                    scale:1,
                                    x:'0',
                                    y:'0',
                                    duration:.8
                                },'<') 
                            }
                            _this.flag1999 = {image1:true}
                        }
                        if(data_num ==2009){
                            if(progress > 0.2 && !_this.flag2009.image1){
                                // console.log('0000');
                                // to('.bg-2009',{
                                //     opacity:0,
                                //     scale:.4,
                                //     scale:1,
                                //     duration:2,
                                // }).
                                tl2.to('.bg-2009-1',{
                                    // delay:2,
                                    // opacity:1,
                                    scale:1,
                                    x:0,
                                    duration:2,
                                });
                                _this.flag2009= {
                                    image1:true
                                };
                            }
                        }
                        if(data_num ==2014){
                            if(0<progress && progress<=0.25 &&  !_this.flag2014.image1){
                                tl2.to('.bg-2014-1',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014-2',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014',{
                                    opacity:1,
                                    duration:.8,
                                },'-=0.4');
                                _this.flag2014= {
                                    image1:true
                                };
                            }
                            if(0.25<progress && progress<=0.5 &&  !_this.flag2014.image2){
                                tl2.to('.bg-2014',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014-2',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014-1',{
                                    opacity:1,
                                    duration:.8,
                                },'-=0.4');
                                _this.flag2014= {
                                    image2:true
                                };
                            }
                            if(0.5<progress &&  !_this.flag2014.image3){
                                tl2.to('.bg-2014',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014-1',{
                                    opacity:0,
                                    duration:.2,
                                }).to('.bg-2014-2',{
                                    opacity:1,
                                    duration:.8,
                                },'-=0.4');
                                _this.flag2014= {
                                    image3:true
                                };
                            }
                        }
                    },
                    onEnter:()=>{
                        section.img_arrow_wraper = section.querySelector('.img-arrow-wraper');
                        if(section.img_arrow_wraper){
                            tl.from('.img-arrow-wraper img',{
                                delay:.8,
                                opacity:0,
                                scale:0,
                                stagger:0.3,
                            })
                        }
                        $(section.bg).animate({opacity:1},1000);
                    },
                    onLeaveBack:(ele)=>{
                        $(section.bg).animate({opacity:0},500);
                    },
                    onLeave:(ele)=>{
                        $(section.bg).animate({opacity:0},500);
                        $(section.content_time).removeClass('content-time-fixed');
                        $(section.content_time_placeholder).css({"position":'fixed'});
                    },
                    onEnterBack:()=>{
                        $(section.bg).animate({opacity:1},1000);
                    },
                }
            });
            section.img_agriculture = section.querySelector('.img_agriculture');
            if(section.img_agriculture){
                tl.from(section.bg,{
                    scale:.8,
                    opacity:0,
                    duration:1.2,
                })
            }
            section.img_arrow_wraper = section.querySelector('.img-arrow-wraper');
            if(section.img_arrow_wraper){
                tl.from('.img-arrow-wraper img',{
                    delay:1,
                    opacity:0,
                    scale:0,
                    stagger:0.6,
                })
            }
        })
    }
     // 调整 html 字体大小
     getScrollWidth = () => {
        let noScroll, scroll, oDiv = document.createElement("DIV");
        oDiv.style.cssText = "position:absolute; top:-9999px; width:100px; height:100px; overflow:hidden;";
        noScroll = document.body.appendChild(oDiv).clientWidth;
        oDiv.style.overflowY = "scroll";
        scroll = oDiv.clientWidth;
        document.body.removeChild(oDiv);
        return noScroll - scroll;
    }
    IsPC = () => {
        var userAgentInfo = navigator.userAgent;
        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
        }
        return flag;
    }
    resize = () => {
        let window_width = window.innerWidth - this.getScrollWidth();
        this.rule_num = window_width * 20 / 428;
        let pc_num = window_width * 100 / 1920;
        if (this.IsPC()) {
            $("html").css("font-size", pc_num + "px");
        }
        else {
            $("html").css("font-size", this.rule_num + "px");
        }


    }
    // shareClick(){
    //     if(this.state.onOff){
    //         $('#social_icons-magic').css('left','25px')
    //         this.setState({
    //             onOff : false
    //         })
    //     }else{
    //         $('#social_icons-magic').css('left','0')
    //         this.setState({
    //             onOff : true
    //         })
    //     }
    //     $('#social_icons').toggleClass('active')
    // }
    render() {
        return <div className='m-main'>
            <Disable />
            {/* <progress value="0" max="100"></progress> */}
            <div className="m-home-title">
                <img src={m_cgtn}/>
                <a className='m-title-conflict' href="https://news.cgtn.com/event/2022/Russia-Ukraine-Conflict-Tracker/index.html">
                    Conflict Tracker
                </a>
                <a className='m-title-change' href="https://news.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/index.html"><span>EN </span>/中文</a>
            </div>
            <div className="m-home-wraper m-home1">
                {/* <div className="share-box" >
                    <a href="javascript:;"><img id="share_btn" onClick={()=>this.shareClick()}  className="share-btn" src={require("../../assets/images/m/share/share-btn.png")} alt="Share" /></a>
                    <div id="social_icons-magic" className="social-icons-magic"></div>
                    <div id="social_icons" className="social-icons">
                        <a className="share-fb" target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https://newstest.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/index.html"></a>
                        <a className="share-twitter" target="_blank" href="https://twitter.com/intent/tweet?text=Historical Map: Ukraine Crisis&url=https://newstest.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/index.html"></a>
                        <a className="share-sina" target="_blank" href="http://service.weibo.com/share/share.php?appkey=4122844478&title=Historical Map: Ukraine Crisis&url=https://newstest.cgtn.com/event/2022/Historical-Map-Ukraine-Crisis/index.html"></a>
                    </div>
                </div> */}
                
                <div className="m-home" >
                    <div className="shadow_people"></div>
                    <div className="m-home-content">
                        <div className='m-home-tilte'>
                            俄乌历史经纬
                        </div>
                        <div className="m-home-line"></div>
                        <div className='m-home-subtitle'>
                            历史事件的原因是一切原因的总和，这是唯一的原因。
                            <div style={{textAlign:'right'}}>——《战争与和平》</div>
                        </div>
                    </div>
                    <div className={'m-cylinder-wrapper'}>
                        <Cylinder />
                    </div>
                    <div className='m-home-next'>
                        <span>向下滑动 探索更多</span>
                        <span>
                            <span className='arrow_down'></span>
                        </span>
                    </div>
                </div>
            </div>
            <div className="m-home-wraper m-home2" style={{width:'100vw',height:'4vh',background:'#000',position:'relative',marginTop:'-0.1rem'}}>

            </div>
            <div className="content-wrap">
                {/* <div className='content-background-wraper'>

                </div>
                <div className="content-section-wraper">

                </div> */}
                {/* 1 */}
                <section className="content-section">
                    <div className="bg">
                        <div className="home-content-box">
                        乌克兰为何重要？<br/>
                        乌克兰地处东欧平原，其地理位置特殊，位于欧洲与俄罗斯地缘政治交汇处。土地面积仅次于俄罗斯，为欧洲第二大国。俄乌两国都曾是前苏联的加盟国。
                        </div>
                    </div>
                    <div className= "bg-title"></div>
                    <div className='content'>
                        <div className="content-time"></div>
                        <div className='content-title'></div>
                        {/* <div className="content-box">
                            <div className="content-summary">
                            </div>
                        </div> */}
                    </div>
                    {/* <div className="title-end"  style={{height:1,opacity:0}}></div> */}

                </section>
                {/* 2 */}
                <section className="content-section">
                    <div className="bg">
                        <div className="img_agriculture">
                            <img src={img_agriculture}/>
                        </div>
                        <div className='img-arrow-wraper'>
                            <img src= {img_arrow_1}/>
                            <img src= {img_arrow_2}/>
                            <img src= {img_arrow_3}/>
                            <img src= {img_arrow_4}/>
                            <img src= {img_arrow_5}/>
                        </div>
                    </div>
                    <div className= "bg-title"></div>
                    <div className='content'>
                        <div className="content-time"></div>
                        <div className='content-title content-title-orange'>欧洲“粮仓”</div>
                        <div className="content-box">
                            <div className="content-summary">
                            乌克兰拥有地球四分之一的黑土地，且全国71%的土地为耕地。乌克兰是世界第四大玉米出口国及第五大小麦出口国。2020年葵花籽油出口量位居全球首位，占世界葵花籽油出口量总数的40%。
                            </div>
                        </div>
                    </div>
                    {/* <div className="title-end"  style={{height:1,opacity:0}}></div> */}

                </section>
                {/* home-3 */}
                <section className="content-section">
                    <div className="bg">
                        <div className="img_gas">
                            <img src = {icon_gas} className="icon_gas"/>
                            <img src={img_gas}/>
                        </div>
                        <div className='img-gas-arrow'>
                            <img src= {img_gas_arrow_2}/>
                            <img src= {img_gas_arrow_1}/>
                        </div>
                    </div>
                    <div className= "bg-title"></div>
                    <div className='content'>
                        <div className="content-time"></div>
                        <div className='content-title content-title-orange'>欧洲“气管”</div>
                        <div className="content-box">
                            <div className="content-summary">
                            乌克兰拥有重要的俄欧天然气运输管道。2021年，416亿立方米的俄罗斯天然气经乌克兰运送至欧洲，占欧洲从俄罗斯进口天然气总量的26.8%。
                            </div>
                        </div>
                    </div>
                    {/* <div className="title-end"  style={{height:1,opacity:0}}></div> */}

                </section>
                {/* home-4 */}
                <section className="content-section">
                    <div className="bg">
                        <div className="img_nuclear">
                            <img src={img_nuclear}/>
                            <img src = {icon_nuclear} className="icon_nuclear"/>
                        </div>
                    </div>
                    <div className= "bg-title"></div>
                    <div className='content'>
                        <div className="content-time"></div>
                        <div className='content-title content-title-orange'>欧洲“核心”</div>
                        <div className="content-box">
                            <div className="content-summary">
                            乌克兰共有四座核电站，皆为苏联时期所造。其中，扎波罗热核电站为欧洲最大核电站。2020年，乌克兰的核电发电量为76202吉瓦时，位居世界第七。
                            </div>
                        </div>
                    </div>
                    {/* <div className="title-end"  style={{height:1,opacity:0}}></div> */}
                </section>
                {/* 5 */}
                <section className="content-section">
                    <div className="bg">
                        <div className="img_money">
                            <img src={img_money}/>
                            <img src={icon_money} className="icon_money"/>
                        </div>
                    </div>
                    <div className= "bg-title"></div>
                    <div className='content'>
                        <div className="content-time"></div>
                        <div className='content-title content-title-orange'>与北约的“特殊关系”</div>
                        <div className="content-box">
                            <div className="content-summary">
                            {/* Ukraine-NATO relations started in the early 1990s soon after the country's independence from the USSR. Ukraine is also <span style={{color:'#beab62',fontWeight:'600'}}>  one of the leading recipients of aid from NATO members.</span> From 2014 to 2021, Ukraine received more than $2.5 billion in military aid from the U.S. */}
                            乌克兰与北约的关系始于苏联解体。<span style={{color:'#beab62',fontWeight:'600'}}>虽然乌克兰未正式加入北约，但以美国为首的北约国家却一直为乌克兰提供军事援助。</span>从2014年到2021年，乌克兰从美国获得了超过25亿美元的军事援助。
                            </div>
                        </div>
                    </div>
                    {/* <div className="title-end"  style={{height:1,opacity:0}}></div> */}
                </section>
                
                
                {/* 1991 */}
                <section className="content-section content-section-1991" data-num = "1991">
                    <div className="bg" style={{backgroundColor:'#000',opacity:0}}>
                        <div className="bg-1991 bg-1991-1"></div>
                        <div className="bg-1991 bg-1991-2"></div>
                        <div className="bg-1991 bg-1991-3"></div>
                        <div className="bg-1991 bg-1991-4"></div>
                    </div>
                    <div className='content'>
                        <div className="content-time">1991</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue-front'>乌克兰独立</div>
                        <div className="content-box">
                            <div className="content-summary">
                                1991年8月24日，乌克兰政府发表《乌克兰独立宣言》，正式宣布脱离苏联独立。
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                                12月26日，苏联最高苏维埃共和国院举行最后一次会议，宣布苏联停止存在。前苏联解体为15个国家：俄罗斯，乌克兰，白俄罗斯，摩尔多瓦，格鲁吉亚，亚美尼亚，阿塞拜疆，塔吉克斯坦，吉尔吉斯斯坦，哈萨克斯坦，土库曼斯坦，乌兹别克斯坦，立陶宛，拉脱维亚和爱沙尼亚。
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                                独立后的乌克兰东北部与俄罗斯接壤，北临白俄罗斯，而其西部接壤的波兰、匈牙利、斯洛伐克及南部的罗马尼亚都在此后十几年间先后加入了“西方阵营”——北约。
                            </div>
                        </div>

                        {/* 2 */}
                        <div className="content-box" style={{marginTop:'80vh'}}>
                            <div className="content-summary">
                                <div style={{fontWeight:800}}>什么是北约? </div>
                                {/* The North Atlantic Treaty Organization was created in 1949 by <span style={{color:'#beab62',fontWeight:'600'}}>the U.S., 
                                Canada and several Western European nations. </span>
                                The military alliance now includes<span style={{color:'#beab62',fontWeight:'600'}}> 30 countries.</span> */}
                                北大西洋公约组织（简称北约），是<span style={{color:'#beab62',fontWeight:'600'}}>是由美国、英国、法国、加拿大等西方国家在1949年建立的军事联盟。现已有30个成员国。</span>
                                <div style={{marginTop:'1.2rem'}}>
冷战时期，北约的根本目的是抗衡苏联领导的华沙条约组织。后冷战时代，北约以向盟国提供“绝对安全保障”为由，持续东扩。这一超级军事集团不仅对世界和平没有发挥积极作用，相反，世界大部分冲突和紧张的局势都与它有关，包括科索沃战争、阿富汗战争、伊拉克战争和利比亚战争。</div>
                                <div>(此处地图展示时期为1990年10月3日至1991年6月25日)</div>
                            </div>
                        </div>
                        {/* 3 */}
                        <div className="content-box" style={{marginTop:'90vh'}}>
                            <div className="content-summary">
                            <div style={{fontWeight:800}}>什么是华约?</div> 
                                1955年，旨在对抗北约势力的华沙条约组织（简称华约）成立。华约由苏联及其他七个欧洲社会主义阵营国家组成。华约与北约分别代表了东西方不同的意识形态，针锋相对。
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                                1990年，东德与西德完成统一，东德随即退出华约，并加入了北约，成为第一个加入北约的华约成员国。 
                            </div>
                        </div>
                        {/* 4 */}
                        <div className="content-box" style={{marginTop:'60vh'}}>
                            <div className="content-summary">
                                1991年7月1日，华约正式解散。
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>
                </section>
                {/* 1994 */}
                <section className="content-section">
                    <div className="bg"></div>
                    <div className= "bg-title bg-title-right">1994</div>
                    <div className='content'>
                        <div className="content-time" style={{textAlign:'right',right:'0'}}>1994</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue' style={{textAlign:'right'}}>布达佩斯</div>
                        <div className='content-title ' style={{textAlign:'right'}}>安全保障备忘录</div>
                        <div className="content-box">
                            <div className="content-summary">
                            作为苏联时期重要的军事工业中心，独立的乌克兰继承了一笔可观的苏联核遗产——约1900枚核弹头。这使乌克兰成为了当时核武器储备第三大国，仅在美俄之后。同为前苏联加盟国的白俄罗斯和哈萨克斯坦也继承了苏联庞大的核遗产。于是，在力主三国弃核的问题上，美俄达成了共识。
                            </div>
                        </div>
                        <div className="content-box">
                            <div className="content-summary">
                            1994年12月5日，美国、俄罗斯、英国、乌克兰、白俄罗斯、哈萨克斯坦六国于匈牙利首都布达佩斯签署了《布达佩斯安全保障备忘录》。美、俄、英承诺为乌、白、哈提供安全保障，但作为交换，三国需放弃并销毁自己所有的核武器。美、俄、英同时承诺不会对乌克兰使用武力或经济胁迫。
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'70vh'}}>
                            <div className="content-summary">
                            同月，北约在布鲁塞尔举行的北约外长会议上开始公开讨论其向东扩张的议题，俄罗斯总统叶利钦怒不可遏，并在签订布达佩斯备忘录的当天，指责“霸道”的美国通过北约扩张“试图再次分裂欧亚大陆”。
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 1999 */}
                <section className="content-section" data-num="1999">
                    <div className="bg">
                        {/* <div className="shown_up"></div> */}
                        <div className='bg-wraper'>
                            <div className="bg-1999"></div>
                            <div className="m_1999_font"></div>
                            <div className="bg-zoomOut"></div>
                            <div className="m_1999_2_2_front"></div>
                        </div>
                        {/* <div className="shown_down"></div> */}
                    </div>
                    {/* <div className= "bg-title">1999</div> */}
                    <div className='content'>
                        <div className="content-time">1999</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue-front'>北约首次东扩：</div>
                        <div className='content-title '>前华约三国加入北约</div>
                        <div className="content-box">
                            <div className="content-summary">
                            1999年1月，北约向前华约国家波兰、匈牙利和捷克发出邀请。在北约内部的激烈争论和俄罗斯的强烈反对下，三国于3月12日正式签署加入北约协定，这是北约势力在冷战后的第一次扩张。
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'80vh'}}>
                            <div className='m_1999_i'>
                                <img src={m_1999_i}/>
                            </div>
                            <div className="content-summary">
                            同月，北约在科索沃战争期间对前南斯拉夫联盟共和国进行了大规模空袭轰炸。这让俄罗斯反思“与西方保持友好关系的尝试可能是一个错误”。
                            {/* <br/> */}
                            <div style={{marginTop:'1.2rem'}}>
                                前南斯拉夫外交官维斯科·加塞维奇指出，北约在未经联合国批准的情况下单方面轰炸南联盟的决定标志着俄罗斯与西方关系的转折点。
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2004 */}
                <section className="content-section">
                    <div className="bg bg-zoomOut"></div>
                    {/* <div className= "bg-title bg-title-right">2004</div> */}
                    <div className='content'>
                        <div className="content-time" style={{textAlign:'right',right:'0'}}>2004</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue' style={{textAlign:'right'}}>北约再次东扩:</div>
                        <div className='content-title ' style={{textAlign:'right'}}>波罗的海三国加入北约</div>
                        <div className="content-box">
                            <div className="content-summary">
                            2004年3月29日，北约迎来了七个新成员：保加利亚、罗马尼亚、斯洛伐克、斯洛文尼亚，以及波罗的海三国——爱沙尼亚、拉脱维亚和立陶宛。
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                            18世纪末到20世纪初，波罗的海三国曾是沙俄版图的一部分。这三个国家的海岸线极大地拓宽了俄罗斯的出海口，无论在贸易或军事上均具有重要战略意义。自古以来，欧洲各国为在波罗的海称雄，屡次发动战争。
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'80vh'}}>
                            <div className="content-summary">
                                {/* Initially, the idea of the Baltic nations joining NATO was not well-received by U.S. policymakers, 
                                because of the countries' deep historical ties with Russia. But the Baltic states went out of their way to appeal to the West. 
                                After gaining independence in 1991, these countries were determined to join NATO and the European Union and went through political and economic reforms to meet the entry requirements.
                                <span style={{fontWeight:600,color:'#beab62'}}> In 2004, they became the first post-Soviet states to join NATO.</span> */}
                                由于波罗的海三国与俄罗斯之间深厚的历史渊源，美国起初并未接受三国加入北约。但三国为了加盟入约，自1991年独立后，就迅速进行了一系列政治和经济改革以满足北约的要求。<span style={{fontWeight:600,color:'#beab62'}}>2004年，它们成为了第一批加入北约的前苏联国家。</span>
                            </div>
                        </div>
                        {/* <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                            Russian Foreign Minister Sergey Lavrov called NATO's eastward expansion a mistake back in 2004. 
                            ''The presence of American soldiers on our border has created a kind of paranoia in Russia,''
                             Lavrov said in a meeting with NATO ministers in Brussels that year.
                            </div>
                        </div> */}
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2008 */}
                <section className="content-section" style={{paddingBottom:'80vh'}}>
                    <div className="bg bg-zoomOut"></div>
                    {/* <div className= "bg-title">2008</div> */}
                    <div className='content'>
                        <div className="content-time">2008</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue-front'>北约东扩仍在继续： </div>
                        <div className='content-title '>乌克兰申请加入 </div>
                        <div className="content-box">
                            <div className='m_1999_i'>
                                <img src={m_2008_i}/>
                            </div>
                            <div className="content-summary">
                            2008年3月，在乌克兰总统维克托·尤先科和总理季莫申科的领导下，乌克兰正式申请加入北约“成员国行动计划”（Membership Action Plan），该行动计划被认为是“加入北约的第一步”，即成为“北约发展对象”。
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'70vh'}}>
                            <div className="content-summary">
                            4月，在布加勒斯特举行的北约峰会就是否准许乌克兰加入北约展开了激烈辩论。俄罗斯总统普京受邀前往。
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">美国前总统布什和波兰前总统卡钦斯基大力支持乌克兰加入北约，同时，也有反对的声音。除俄罗斯外，英、法、德三国都不赞成乌克兰的加入。最终，乌克兰未能在此次峰会获得成员资格。然而，北约秘书长夏侯雅伯承诺，乌克兰加入北约的大门总有一天会敞开。 </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                            在这次峰会上，北约称在成员国部署的导弹防御系统并非针对俄罗斯，但普京回应称此类说法不会缓解俄罗斯的担忧：“国家安全不是基于承诺，在北约前几次扩张前发表的声明都证实了这一点。
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2009 */}
                <section className="content-section" data-num = "2009" style={{paddingBottom:'80vh'}}>
                    <div className="bg bg-zoomOut" style={{background:'#000'}}>
                        {/* <div className="shown_up"></div> */}
                        {/* <div className="bg-2009"></div> */}
                        <div className="bg-2009-1"></div>
                        {/* <div className="shown_down"></div> */}
                    </div>
                    {/* <div className= "bg-title bg-title-right">2009</div> */}
                    <div className='content'>
                        <div className="content-time" style={{textAlign:'right',right:'0'}}>2009</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue' style={{textAlign:'right'}}>阿尔巴尼亚和克罗地亚加入北约</div>
                        <div className="content-box">
                            <div className="content-summary">
                            2009年，阿尔巴尼亚和克罗地亚成为北约扩张的新成员。随着阿尔巴尼亚的加入，大多数前华约国家至此都加入了北约。
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2013 */}
                <section className="content-section">
                    <div className="bg"></div>
                    {/* <div className= "bg-title">2013</div> */}
                    <div className='content'>
                        <div className="content-time">2013</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue-front'>乌克兰反政府示威</div>
                        <div className="content-box">
                            <div className="content-summary">
                            2013年11月，乌克兰总统亚努科维奇暂停了与欧盟签订联系国协定，转而寻求与俄罗斯建立更密切的关系，这一决定在乌克兰首都基辅引发了一波又一波的抗议。骚乱在2014年2月升级并达到高潮，抗议者和警察之间的武力冲突造成多起死伤。
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'70vh'}}>
                            <div className="content-summary">
                            2014年2月21日，为了结束动荡，亚努科维奇和议会反对党领袖签署了一项协议，将在12月之前组建联合政府、进行宪法改革和重新举行总统选举。但第二天，亚努科维奇即被议会集体投票赶下台。
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                            3月11日，乌克兰克里米亚自治共和国通过决议，批准关于该共和国和塞瓦斯托波尔市独立的宣言。
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2014 */}
                <section className="content-section" data-num = "2014">
                    <div className="bg">
                        <div className = "bg-2014"></div>
                        <div className = "bg-2014-1"></div>
                        <div className = "bg-2014-2"></div>
                    </div>
                    {/* <div className= "bg-title bg-title-right">2014</div> */}
                    <div className='content'>
                        <div className="content-time" style={{textAlign:'right',right:'0'}}>2014</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue' style={{textAlign:'right'}}>克里米亚危机</div>
                        <div className="content-box">
                            <div className="content-summary">
                            2014年3月16日，克里米亚自治共和国议会决定举行关于共和国地位的全民公投：独立并加入俄罗斯还是继续作为乌克兰的一部分。百分之九十七的人投票加入俄罗斯。随后的第68届联合国大会投票通过有关乌克兰问题决议，申明16日在克里米亚自治共和国和塞瓦斯托波尔市举行的全民公投“无效”，“不能成为改变克里米亚自治共和国和塞瓦斯托波尔市地位的基础”。美、英、法等100个国家投赞成票，俄罗斯、古巴等11个国家投票反对，中国、巴西、印度等58个国家弃权。
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'70vh'}}>
                            <div className="content-summary">
                            克里米亚独立公投后，克里米亚共和国成立，并于3月18日加入俄罗斯，与塞瓦斯托波尔市共同组成克里米亚联邦区。乌克兰政府并不承认这次公投。4月15日，乌克兰议会宣布克里米亚是被俄罗斯“暂时占领的领土”。北约对乌克兰表示支持，称公投“直接违反了乌克兰宪法和国际法”。
                            </div>
                        </div>
                        <div className='content-title content-title-blue' style={{textAlign:'right',marginTop:'70vh'}}>乌东再现</div>
                        <div className='content-title ' style={{textAlign:'right'}}>“克里米亚危机”</div>
                        {/* <div  className='content-title' style={{textAlign:'right'}}>in eastern Ukraine</div> */}
                        <div className="content-box">
                            <div className="content-summary">
                            同年5月，乌克兰东部顿巴斯地区，亲俄民间武装势力亦爆发与政府军之间的冲突，随后宣布从乌克兰“独立”，自立“顿涅茨克人民共和国”和“卢甘斯克人民共和国”。
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0'}}>
                            <div className="content-summary">
                            2015年2月，俄罗斯、乌克兰、欧洲安全与合作组织（欧安组织）的代表以及顿涅茨克和卢甘斯克地区的领导人在白俄罗斯首都明斯克签署了和平协议。但俄乌双方对协议的解释截然不同，因此该协议最终未能在乌克兰东部实现停火。
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>

                {/* 2019 */}
                <section className="content-section">
                    <div className="bg"></div>
                    {/* <div className= "bg-title ">2019</div> */}
                    <div className='content'>
                        <div className="content-time">2019</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue-front'>泽连斯基当选 </div>
                        <div className="content-box" style={{backgroundColor:'rgba(0,0,0,0.7)'}}>
                            <div className="content-summary">
                            2019年，乌克兰著名演员泽连斯基在大选中以压倒性优势战胜了时任总统波罗申科，赢得超70%的选票，并于5月20日正式就任乌克兰第六任总统。 
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0',backgroundColor:'rgba(0,0,0,0.7)'}}>
                            <div className="content-summary">
                            {/* In his campaign, Zelenskyy promised to smooth tensions with Russia and end the conflict in the east of his country. However, Ukraine's ties with NATO deepened as Russia-Ukraine relations continued to deteriorate. In June 2020, Ukraine was <span style={{fontWeight:600,color:"#beab62"}}>recognized by NATO as an Enhanced Opportunities Partner</span>, joining Australia, Finland, Georgia, Jordan and Sweden. NATO claimed the new status did not "prejudge" formal membership, but said Ukraine would continue to receive support from NATO allies "in the security and defense sector." */}
                            泽连斯基在竞选中曾承诺将缓和与俄罗斯的紧张关系，并结束乌克兰东部持续多年的武装冲突。但是过去几年里，乌克兰与北约的关系进一步加深，这也导致俄乌关系的持续恶化。<span style={{color:'#beab62',fontWeight:'600'}}>2020年6月，乌克兰与澳大利亚、芬兰、格鲁吉亚、约旦和瑞典获得了北约“增强伙伴国”地位。</span>北约声称这一新地位并不能“预判”乌克兰的正式加入，但表示“乌克兰将继续在安全和国防领域获得北约盟国的支持”。
                            </div>
                        </div>
                        <div className="content-box" style={{marginTop:'70vh',backgroundColor:'rgba(0,0,0,0.7)'}}>
                            <div className="content-summary">
                            2021年，乌克兰三家电视台因“传播俄罗斯的虚假信息”而被停播。普京对此回应称，乌克兰正在走向“俄罗斯的对立面”，俄罗斯需要“从安全角度引起重视”。
                            </div>
                        </div>
                        <div className="content-box" style={{paddingTop:'0',backgroundColor:'rgba(0,0,0,0.7)'}}>
                            <div className="content-summary">
                            2021年底，俄罗斯向北约提出诉求并划下“安全红线”，提出不允许北约进一步东扩、不允许部署威胁俄联邦领土安全的打击性武器的明确立场。但美国和北约的答复未解决俄罗斯的核心关切，继续坚持北约的“门户开放政策”。
                            </div>
                        </div>
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>

                </section>
                {/* 2022 */}
                <section className="content-section" style={{paddingBottom:'35vh'}}>
                    <div className="bg"></div>
                    {/* <div className= "bg-title bg-title-right">2022</div> */}
                    <div className='content'>
                        <div className="content-time" style={{textAlign:'right',right:'0'}}>2022</div>
                        <div className="content-time-placeholder"></div>
                        <div className='content-title content-title-blue' style={{textAlign:'right'}}>普京承认</div>
                        <div className='content-title' style={{textAlign:'right'}}>乌东两个“共和国”</div>
                        <div className="content-box">
                            <div className="content-summary">
                            2022年2月22日，普京承认乌克兰东部“顿涅茨克人民共和国”和“卢甘斯克人民共和国”为独立的主权国家。乌克兰称此举侵犯其国家主权。24日，普京在电视讲话中宣布将开始一项“特别军事行动”，使乌克兰“去军事化”和“去纳粹化”。普京称，“行动”的目的并不包括占领乌克兰领土。同日，俄罗斯军方对乌克兰境内的数十个军事目标发动进攻。
                            </div>
                        </div>
                        
                    </div>
                    <div className="title-end"  style={{height:1,opacity:0}}></div>
                    <div className="copy-right">
                        <div>本产品内所有地图仅作示意使用</div>
                        <div>Copyright © 2022 CGTN All Rights Reserved.</div>
                    </div>
                </section>
            </div>
        </div>
    }

}

export default M;
